import axios from 'axios';

// Use relative URL in production (works on any domain), absolute in development
const API = process.env.NODE_ENV === 'production' ? '/api' : `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// News
export const getNews = (category, page = 1, q = '', year = null, month = null) => {
  const params = { page };
  if (category) params.category = category;
  if (q) params.q = q;
  if (year) params.year = year;
  if (month) params.month = month;
  return api.get('/news', { params });
};
export const getNewsArchiveIndex = () => api.get('/news/archive/index');
export const getNewsDetail = (id) => api.get(`/news/${id}`);
export const createNews = (data) => api.post('/news', data);
export const updateNews = (id, data) => api.put(`/news/${id}`, data);
export const deleteNews = (id) => api.delete(`/news/${id}`);
export const getMyNews = () => api.get('/my-news');

// Admin
export const getPendingNews = () => api.get('/admin/news/pending');
export const approveNews = (id) => api.put(`/admin/news/${id}/approve`);
export const rejectNews = (id) => api.put(`/admin/news/${id}/reject`);
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminUsers = () => api.get('/admin/users');
export const getAdminAnalytics = () => api.get('/admin/analytics');
export const getAdminUsersDetails = () => api.get('/admin/users/details');
export const getAdminUserProfile = (id) => api.get(`/admin/user/${id}`);
export const getAdminCredential = (id) => api.get(`/admin/credential/${id}`);
export const adminRegisterUser = (data) => api.post('/auth/register', data);
export const adminDeleteUser = (id) => api.delete(`/admin/users/${id}`);
export const trackVisit = (page) => api.post('/track', { page }).catch(() => {});

// Profile (self)
export const updateMyProfile = (data) => api.put('/auth/me/profile', data);

// Reports (anonymous / admin)
export const submitAnonymousReport = (data) => api.post('/reports', data);
export const reportUploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/reports/upload/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const reportUploadVideo = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/reports/upload/video', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getAdminReports = (status) => api.get('/admin/reports', { params: status ? { status } : {} });
export const updateReportStatus = (id, status) => api.put(`/admin/reports/${id}/status`, { status });
export const deleteReport = (id) => api.delete(`/admin/reports/${id}`);
export const geocodeReport = (id) => api.put(`/admin/reports/${id}/geocode`);

// Auto-news
export const triggerAutoNews = () => api.post('/admin/auto-news/run');
export const getAutoNewsStatus = () => api.get('/admin/auto-news/status');

// Public credential verification (no auth)
export const verifyCredential = (code) => api.get(`/verify/${encodeURIComponent(code)}`);

// Categories
export const getCategories = () => api.get('/categories');

// Uploads
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const uploadVideo = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/video', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const getFileUrl = (path) => `${API}/files/${path}`;

export default api;
